import { render, staticRenderFns } from "./TrendingNews.vue?vue&type=template&id=f0c39242&scoped=true&"
import script from "./TrendingNews.vue?vue&type=script&lang=js&"
export * from "./TrendingNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c39242",
  null
  
)

export default component.exports